/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string | null;
  idLead?: string | null;
  idOportunidade?: string | null;
}

export function useEditarProposta(props: Props) {
  const postData = async () => {
    const EDITAR_ITEM = `${backofficeEnviroment}/common/oportunidades-lead/alterar-proposta/v1/${props.idLead}/${props.idUnidade}/${props.idOportunidade}`;
    const { data } = await instance.put(EDITAR_ITEM);
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Proposta editada com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao editar proposta. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
